export const RulesTypes = {
  Rule: 'rules',
  PrivacyPolicy: 'privacyPolicy',
  PersonalDataConsent: 'personalDataConsent',
  MarketingConsent: 'marketingConsent',
} as const

export type RulesTypes = (typeof RulesTypes)[keyof typeof RulesTypes]
